<template>
  <div>
    <page-header
      icon="mdi-image-multiple"
      :title="$t('gallery')"
      :subtitle="$t('manage_image_gallery')"
    >
      <template #actions>
        <primary-button>
          <label for="upload" style="margin: 0; padding: 0; cursor: pointer">
            <v-icon class="mr-2">mdi-plus-circle</v-icon>
            {{ $t("add_image") }}
          </label>
        </primary-button>
      </template>
    </page-header>

    <page-toolbar v-model="filter" :search-placeholder="$t('search_images_placeholder')">
      <template #filters>
        <input type="file" id="upload" hidden @change="upload" />
      </template>
    </page-toolbar>
    <div v-if="isLoading" class="text-center pa-8">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      <p class="mt-4">{{ $t("loading_data") }}</p>
    </div>

    <div v-else class="px-6 mt-2">
      <v-row>
        <v-col cols="4" md="2" v-for="image in imageList" :key="image.id">
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-img
                :src="galleryUrl(image.name)"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
            <v-col cols="12" class="pt-0 text-center">
              {{ image.name | imageName }}
              <circle-button
                @click="deleteImage(image)"
                icon="mdi-delete"
                color="error"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <global-confirm-box ref="confirmBox"></global-confirm-box>

    <global-dialog-card
      v-model="dialogWrongImageType"
      :max-width="500"
      hide-actions
      :title="$t('wrong_format')"
    >
      <p class="mt-4">
        {{ $t("wrong_image_format") }}
      </p>
    </global-dialog-card>
  </div>
</template>

<script>
import galleryService from "@/services/gallery";
import hasSnackbar from "@/mixins/hasSnackbar";
import PageHeader from "@/components/global/PageHeader.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";

export default {
  components: {
    PageHeader,
    PageToolbar,
  },
  mixins: [hasSnackbar],
  data: () => ({
    filter: null,
    images: [],
    dialogWrongImageType: false,
    isLoading: false,
  }),
  created() {
    this.load();
  },
  methods: {
    upload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      if (!allowedTypes.includes(file.type)) {
        this.dialogWrongImageType = true;
        setTimeout(() => {
          this.dialogWrongImageType = false;
        }, 5000);
        return;
      }

      const data = new FormData();
      data.append("image", file);

      galleryService
        .uploadGalleryImage(data)
        .then((res) => {
          this.images.push(res.data);
          this.showSuccessSnackbar(this.$t("image_uploaded"));
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_adding_image"));
        });
    },
    async load() {
      this.isLoading = true;
      try {
        const res = await galleryService.getGalleryImages();
        this.images = res.data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_images"));
      } finally {
        this.isLoading = false;
      }
    },
    deleteImage(item) {
      this.$refs.confirmBox
        .open(this.$t("delete_confirmation"), this.$t("confirm_delete_image"), {
          color: "error",
        })
        .then(() => {
          galleryService
            .deleteGalleryImage(item.id)
            .then(() => {
              const idx = this.images.findIndex((i) => i.id === item.id);
              if (idx > -1) this.images.splice(idx, 1);
              this.showSuccessSnackbar(this.$t("image_deleted"));
            })
            .catch(() => {
              this.showErrorSnackbar(this.$t("error_deleting_image"));
            });
        })
        .catch(() => {});
    },
  },
  filters: {
    imageName(name) {
      if (typeof name == "string") {
        let imageName = name.split(".");
        if (imageName[0].indexOf("_"))
          imageName[0] = imageName[0].substring(imageName[0].indexOf("_") + 1);
        if (imageName[0].substring(0, 2) === "to")
          imageName[0] = imageName[0].substring(2);
        return imageName[0].replace(/-/g, " ");
      }
    },
  },
  computed: {
    imageList() {
      if (!this.filter) return this.images;
      const re = RegExp(
        `.*${this.filter.replace(/\s+/g, "-").toLowerCase().split("").join(".*")}.*`
      );
      return this.images.filter((i) => i.name.toLowerCase().match(re));
    },
  },
};
</script>
